/**
 * @generated SignedSource<<70007495624271b0db0f965113922851>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "payload"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "payload",
        "variableName": "payload"
      }
    ],
    "concreteType": "Service",
    "kind": "LinkedField",
    "name": "serviceByIdOrSlug",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "tags",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "basicQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "basicQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "55e81aa41890d29a0d45186f90f9c16a",
    "id": null,
    "metadata": {},
    "name": "basicQuery",
    "operationKind": "query",
    "text": "query basicQuery(\n  $payload: String\n) {\n  serviceByIdOrSlug(payload: $payload) {\n    id\n    tags\n  }\n}\n"
  }
};
})();

node.hash = "d9fc1f2eada5e93dd6df872604823e46";

module.exports = node;
